"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverShow = serverShow;
exports.serverShowCartPage = serverShowCartPage;
exports.clientShow = clientShow;
exports.clientShowCartPage = clientShowCartPage;
exports.CartPage = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _orderEdit = require("modals/order-edit");

var _AnimatedComponent = babelHelpers.interopRequireDefault(require("components/AnimatedComponent"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _SiteNavigation = _interopRequireWildcard(require("components/SiteNavigation"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2, _temp, _class3, _descriptor7, _dec, _class5, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _class7, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _dec2, _class9, _descriptor22, _descriptor23, _descriptor24;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || babelHelpers.typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = babelHelpers.getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = babelHelpers.getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return babelHelpers.possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function serverShow(page, props) {
  return "\n\t\t<div class='inner-content container'>".concat(require('react-dom/server').renderToString( /*#__PURE__*/_react.default.createElement(Cart, props)), "</div>\n\t\t").concat(page.inlineScriptArgs(function (props) {
    require('Cart').clientShow(this.querySelector('.inner-content'), props);
  }, props), "\n\t");
}

function serverShowCartPage(page, props) {
  return "\n\t\t<div data-cart-page='true'>".concat(require('react-dom/server').renderToString( /*#__PURE__*/_react.default.createElement(CartPage, props)), "</div>\n\t\t").concat(page.inlineScriptArgs(function (props) {
    require('Cart').clientShowCartPage(this.querySelector('div[data-cart-page]'), props);
  }, props), "\n\t");
}

function clientShow(block, props) {
  require('react-dom').render( /*#__PURE__*/_react.default.createElement(Cart, props), block);
}

function clientShowCartPage(block, props) {
  require('react-dom').render( /*#__PURE__*/_react.default.createElement(CartPage, props), block);
}

var OptionalField = (_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  babelHelpers.inherits(OptionalField, _Component);

  var _super = _createSuper(OptionalField);

  function OptionalField() {
    var _this;

    babelHelpers.classCallCheck(this, OptionalField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this, "name", _descriptor, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "value", _descriptor2, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "open", _descriptor3, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "toggle", _descriptor4, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "setValue", _descriptor5, babelHelpers.assertThisInitialized(_this));
    babelHelpers.initializerDefineProperty(_this, "disabled", _descriptor6, babelHelpers.assertThisInitialized(_this));
    return _this;
  }

  babelHelpers.createClass(OptionalField, [{
    key: "doToggle",
    value: function doToggle() {
      if (this.disabled) return;
      this.toggle();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "poBox"
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.doToggle
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "material-icons",
        "data-icon": this.open ? "remove_circle_outline" : "add_circle_outline"
      }), this.name), /*#__PURE__*/_react.default.createElement(_AnimatedComponent.default, {
        styleName: OptionalField.styleNames,
        start: this.startElement,
        end: this.endElement,
        format: this.formatStyle,
        enter: this.open,
        boxStyle: OptionalField.initialStyle,
        finishElementStyle: this.finishStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/_react.default.createElement("input", {
        disabled: this.disabled,
        type: "text",
        className: "form-control",
        value: this.value,
        onChange: this.doSetValue
      }))));
    }
  }, {
    key: "startElement",
    value: function startElement(el) {
      return {
        height: 0
      };
    }
  }, {
    key: "endElement",
    value: function endElement(el) {
      return {
        height: el.scrollHeight
      };
    }
  }, {
    key: "formatStyle",
    value: function formatStyle(value) {
      return "".concat(value, "px");
    }
  }, {
    key: "finishStyle",
    value: function finishStyle(element, state) {}
  }, {
    key: "doSetValue",
    value: function doSetValue(event) {
      if (this.disabled) return;
      this.setValue(event.target.value);
    }
  }]);
  return OptionalField;
}(_react.Component), _class2.styleNames = ['height'], _class2.initialStyle = {
  height: '0px',
  overflow: 'hidden'
}, _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "open", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "toggle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "disabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doToggle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doToggle"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "startElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "startElement"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "endElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "endElement"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "formatStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "formatStyle"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "finishStyle", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "finishStyle"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doSetValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doSetValue"), _class.prototype)), _class);
var CartHeader = {
  OrderDetail: function OrderDetail(_ref) {
    var mode = _ref.mode;
    return /*#__PURE__*/_react.default.createElement("header", {
      className: mode == 'PreviousOrder' ? 'card-list-header past-order-item' : 'card-list-header'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "top"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Item")), /*#__PURE__*/_react.default.createElement("div", {
      className: "middle without-bottom"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "quantity"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Qty")), /*#__PURE__*/_react.default.createElement("div", {
      className: "price"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Price")), /*#__PURE__*/_react.default.createElement("div", {
      className: "total"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Total"))), mode != 'PreviousOrder' && /*#__PURE__*/_react.default.createElement("div", {
      className: "edit"
    }));
  },
  Cart: (_class3 = /*#__PURE__*/function (_Component2) {
    babelHelpers.inherits(CartHeaderNode, _Component2);

    var _super2 = _createSuper(CartHeaderNode);

    function CartHeaderNode() {
      var _this2;

      babelHelpers.classCallCheck(this, CartHeaderNode);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));
      babelHelpers.initializerDefineProperty(_this2, "contents", _descriptor7, babelHelpers.assertThisInitialized(_this2));
      return _this2;
    }

    babelHelpers.createClass(CartHeaderNode, [{
      key: "clicked",
      value: function clicked(event) {
        event.preventDefault();
        if (this.linkNode) require('layouts/SiteLayout').default.current.navigate(this.linkNode.href);
      }
    }, {
      key: "gotLink",
      value: function gotLink(node) {
        this.linkNode = node;
      }
    }, {
      key: "render",
      value: function render() {
        var contents = this.contents;
        return /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement("h3", {
          onClick: this.clicked
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "material-icons",
          "data-icon": "shopping_cart"
        }), " ", contents.length ? /*#__PURE__*/_react.default.createElement("span", null, Cart.formatPrice(Cart.getTotal(contents))) : /*#__PURE__*/_react.default.createElement("span", {
          className: "empty"
        }, "Cart Is Empty"), contents.length > 0 && /*#__PURE__*/_react.default.createElement("a", {
          ref: this.gotLink,
          className: "btn btn-primary",
          href: "orderreview"
        }, "View Cart")));
      }
    }]);
    return CartHeaderNode;
  }(_react.Component), (_descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "contents", [_decorators.prop], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "clicked", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "clicked"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "gotLink", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "gotLink"), _class3.prototype)), _class3),
  PreviousOrder: function PreviousOrder() {
    return /*#__PURE__*/_react.default.createElement(CartHeader.OrderDetail, {
      mode: "PreviousOrder"
    });
  }
};
var CartFooter = {
  OrderDetail: function OrderDetail(_ref2) {
    var cart = _ref2.cart,
        isSubmitting = _ref2.isSubmitting,
        hasPoNumber = _ref2.hasPoNumber,
        poNumber = _ref2.poNumber,
        hasComment = _ref2.hasComment,
        comment = _ref2.comment;
    return cart.contents.length > 0 && /*#__PURE__*/_react.default.createElement("footer", {
      className: "order-details"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "total"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Order Total")), /*#__PURE__*/_react.default.createElement("div", {
      className: "right"
    }, /*#__PURE__*/_react.default.createElement("p", null, cart.formatPrice(cart.getTotal())))), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(OptionalField, {
      disabled: isSubmitting,
      name: "Add P.O. Number",
      open: hasPoNumber,
      value: poNumber,
      toggle: cart.togglePoNumber,
      setValue: cart.setPoNumber
    }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(OptionalField, {
      disabled: isSubmitting,
      name: "Add Comment",
      open: hasComment,
      value: comment,
      toggle: cart.toggleComment,
      setValue: cart.setComment
    }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "btn-container"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "javascript:void(0)",
      "data-spin": isSubmitting ? 'true' : void 0,
      onClick: cart.placeOrder,
      className: _classList.default.join('btn', 'btn-primary', isSubmitting && 'spinning')
    }, "Submit Order")));
  },
  Cart: function Cart(_ref3) {
    var contents = _ref3.contents,
        hasPreviousOrders = _ref3.hasPreviousOrders;
    return contents.length > 0 ? /*#__PURE__*/_react.default.createElement("footer", null, /*#__PURE__*/_react.default.createElement("a", {
      className: "btn btn-primary",
      href: "orderreview"
    }, "Review and Submit")) : null;
  } // {false && hasPreviousOrders && <a href='pastorders' className='past-orders'>View previous orders</a>}
  ,
  PreviousOrder: function PreviousOrder(_ref4) {
    var cart = _ref4.cart,
        previousOrder = _ref4.previousOrder;
    return /*#__PURE__*/_react.default.createElement("footer", {
      className: "order-details"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "total"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "left"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Order Total")), /*#__PURE__*/_react.default.createElement("div", {
      className: "right"
    }, /*#__PURE__*/_react.default.createElement("p", null, cart.formatPrice(cart.getTotal())))), /*#__PURE__*/_react.default.createElement("hr", null), previousOrder.comment ? /*#__PURE__*/_react.default.createElement("div", {
      className: "comment"
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "comment-header"
    }, "Comment:"), /*#__PURE__*/_react.default.createElement("p", null, previousOrder.comment)) : null);
  }
};
var Cart = (_dec = (0, _decorators.alias)("state.contents"), (_class5 = /*#__PURE__*/function (_Component3) {
  babelHelpers.inherits(Cart, _Component3);

  var _super3 = _createSuper(Cart);

  function Cart() {
    var _this3;

    babelHelpers.classCallCheck(this, Cart);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this3, "hasPreviousOrders", _descriptor8, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "mode", _descriptor9, babelHelpers.assertThisInitialized(_this3));
    babelHelpers.initializerDefineProperty(_this3, "previousOrder", _descriptor10, babelHelpers.assertThisInitialized(_this3));
    _this3.state = {
      hasPoNumber: false,
      poNumber: "",
      hasComment: false,
      comment: "",
      contents: _this3.props.contents,
      isSubmitting: false
    };
    babelHelpers.initializerDefineProperty(_this3, "contents", _descriptor11, babelHelpers.assertThisInitialized(_this3));
    return _this3;
  }

  babelHelpers.createClass(Cart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.mode == 'Cart') {
        Cart.currentCart = this;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.mode == 'Cart') {
        if (Cart.currentCart == this) {
          Cart.currentCart = null;
        }
      }
    }
  }, {
    key: "placeOrder",
    value: function placeOrder() {
      var _this4 = this;

      if (this.state.isSubmitting) return;
      var body = {
        knownPrice: this.getTotal(),
        comments: this.state.hasComment ? this.state.comment : "",
        poNumber: this.state.hasPoNumber ? this.state.poNumber : ""
      };
      this.setState({
        isSubmitting: true
      }, function () {
        (0, _fetch.default)('data/cart/submit', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }).then(function (data) {
          return data.json();
        }).then(function (result) {
          _SiteNavigation.default.cartUpdated();

          if (result.error) {
            if (result.refreshCart) _this4.setState({
              isSubmitting: false,
              error: result.error,
              contents: result.refreshCart
            });else _this4.setState({
              isSubmitting: false,
              error: result.error
            });
          } else {
            require('layouts/SiteLayout').default.current.navigate(result.reviewLink);
          }
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.contents !== this.props.contents) {
        this.setState({
          contents: this.props.contents
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var Header = CartHeader[this.mode],
          Footer = CartFooter[this.mode];
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "cart-wrapper",
        "data-empty": this.contents.length === 0
      }, this.props.children, /*#__PURE__*/_react.default.createElement("div", {
        className: "cart-container"
      }, /*#__PURE__*/_react.default.createElement(Header, _extends({}, this.props, this.state)), this.contents.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "cart card-container card-list"
      }, this.contents.map(function (item) {
        return /*#__PURE__*/_react.default.createElement(Item, _extends({
          isPreviousOrder: _this5.mode == 'PreviousOrder',
          disabled: _this5.state.isSubmitting || _this5.mode == 'PreviousOrder',
          orderDetail: _this5.mode == 'OrderDetail',
          key: item.id
        }, item));
      })), this.contents.length == 0 && this.mode == 'OrderDetail' && /*#__PURE__*/_react.default.createElement("div", {
        className: "cart empty"
      }, /*#__PURE__*/_react.default.createElement("p", null, "Your cart is empty")), /*#__PURE__*/_react.default.createElement(Footer, _extends({
        className: "footer",
        cart: this
      }, this.props, this.state))));
    }
  }, {
    key: "_toggle",
    value: function _toggle(name) {
      this.setState(function (st) {
        return babelHelpers.defineProperty({}, name, !st[name]);
      });
    }
  }, {
    key: "_set",
    value: function _set(name, value) {
      this.setState(babelHelpers.defineProperty({}, name, value));
    }
  }, {
    key: "getTotal",
    value: function getTotal() {
      return Cart.getTotal(this.contents);
    }
  }, {
    key: "togglePoNumber",
    value: function togglePoNumber() {
      this._toggle('hasPoNumber');
    }
  }, {
    key: "toggleComment",
    value: function toggleComment() {
      this._toggle('hasComment');
    }
  }, {
    key: "setPoNumber",
    value: function setPoNumber(v) {
      this._set('poNumber', v);
    }
  }, {
    key: "setComment",
    value: function setComment(v) {
      this._set('comment', v);
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      return Cart.formatPrice(amount);
    }
  }], [{
    key: "updateCart",
    value: function updateCart() {
      if (Cart.currentCart || _SiteNavigation.ClientSelect.current) {
        (0, _fetch.default)('data/cart').then(function (d) {
          return d.json();
        }).then(function (contents) {
          if (Cart.currentCart) Cart.currentCart.setState({
            contents: contents
          });
          if (_SiteNavigation.ClientSelect.current) _SiteNavigation.ClientSelect.current.setCart(contents);
        });
      }
    }
  }, {
    key: "getTotal",
    value: function getTotal(contents) {
      return contents.map(function (item) {
        return item.quantity * item.price;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);

      var _amount$split = amount.split('.'),
          _amount$split2 = babelHelpers.slicedToArray(_amount$split, 2),
          whole = _amount$split2[0],
          dec = _amount$split2[1];

      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3));
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }]);
  return Cart;
}(_react.Component), (_descriptor8 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "hasPreviousOrders", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "mode", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "Cart";
  }
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "previousOrder", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class5.prototype, "contents", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "placeOrder", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "placeOrder"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "togglePoNumber", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "togglePoNumber"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "toggleComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "toggleComment"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "setPoNumber", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "setPoNumber"), _class5.prototype), babelHelpers.applyDecoratedDescriptor(_class5.prototype, "setComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "setComment"), _class5.prototype)), _class5));
var Item = (_class7 = /*#__PURE__*/function (_Component4) {
  babelHelpers.inherits(Item, _Component4);

  var _super4 = _createSuper(Item);

  function Item() {
    var _this6;

    babelHelpers.classCallCheck(this, Item);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this6 = _super4.call.apply(_super4, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this6, "id", _descriptor12, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "image", _descriptor13, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "title", _descriptor14, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "brandName", _descriptor15, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "quantity", _descriptor16, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "price", _descriptor17, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "orderDetail", _descriptor18, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "disabled", _descriptor19, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "link", _descriptor20, babelHelpers.assertThisInitialized(_this6));
    babelHelpers.initializerDefineProperty(_this6, "isPreviousOrder", _descriptor21, babelHelpers.assertThisInitialized(_this6));
    return _this6;
  }

  babelHelpers.createClass(Item, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("a", {
        className: 'card product' + (this.isPreviousOrder ? ' past-order-item' : ''),
        href: this.disabled ? this.link : void 0,
        onClick: this.disabled ? void 0 : this.showItem
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "image",
        style: {
          backgroundImage: "url(/t/width=400/matte=none/scale/f".concat(this.image, "/image.jpg)")
        }
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "middle without-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "type"
      }, "Product"), /*#__PURE__*/_react.default.createElement("h3", null, this.title), /*#__PURE__*/_react.default.createElement("p", null, this.brandName),
      /* {this.orderDetail ? this.brandName : `${this.quantity} @ ${this.formatPrice(this.price)}`}</p> */
      "")), /*#__PURE__*/_react.default.createElement("div", {
        className: "bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "quantity"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.quantity)), /*#__PURE__*/_react.default.createElement("div", {
        className: "price"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.formatPrice(this.price))), /*#__PURE__*/_react.default.createElement("div", {
        className: "total"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.formatPrice(this.price * this.quantity)))), !this.isPreviousOrder && /*#__PURE__*/_react.default.createElement("div", {
        className: "edit"
      }));
    }
  }, {
    key: "showItem",
    value: function showItem() {
      if (this.disabled) return;
      new _orderEdit.OrderEdit('order-edit', this.props).show();
    }
  }, {
    key: "formatPrice",
    value: function formatPrice(amount) {
      amount = Number(amount).toFixed(2);

      var _amount$split3 = amount.split('.'),
          _amount$split4 = babelHelpers.slicedToArray(_amount$split3, 2),
          whole = _amount$split4[0],
          dec = _amount$split4[1];

      var dd = '';

      while (whole.length > 3) {
        dd = ",".concat(whole.substr(-3));
        whole = whole.substring(0, whole.length - 3);
      }

      dd = whole + dd;
      return "$".concat(dd, ".").concat(dec);
    }
  }]);
  return Item;
}(_react.Component), (_descriptor12 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "brandName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "quantity", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "price", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "orderDetail", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor19 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "disabled", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "link", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "isPreviousOrder", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "showItem", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "showItem"), _class7.prototype)), _class7);
var _default = Cart;
exports.default = _default;
var CartPage = (_dec2 = (0, _decorators.alias)("state.contents"), (_class9 = /*#__PURE__*/function (_Component5) {
  babelHelpers.inherits(CartPage, _Component5);

  var _super5 = _createSuper(CartPage);

  function CartPage() {
    var _this7;

    babelHelpers.classCallCheck(this, CartPage);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this7 = _super5.call.apply(_super5, [this].concat(args));
    babelHelpers.initializerDefineProperty(_this7, "clientName", _descriptor22, babelHelpers.assertThisInitialized(_this7));
    babelHelpers.initializerDefineProperty(_this7, "yourName", _descriptor23, babelHelpers.assertThisInitialized(_this7));
    babelHelpers.initializerDefineProperty(_this7, "contents", _descriptor24, babelHelpers.assertThisInitialized(_this7));
    _this7.state = {
      contents: _this7.props.contents,
      now: new Date()
    };
    return _this7;
  }

  babelHelpers.createClass(CartPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Cart.currentCart = this;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (Cart.currentCart == this) {
        Cart.currentCart = null;
      }
    }
  }, {
    key: "gotCart",
    value: function gotCart(ref) {
      this.cartRef = ref;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderReviewHeader"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "order-review-header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "details-container"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.clientName), /*#__PURE__*/_react.default.createElement("h1", null, "Order Review"), /*#__PURE__*/_react.default.createElement("p", {
        style: {
          textTransform: 'none'
        }
      }, "Please review your order below.", /*#__PURE__*/_react.default.createElement("br", null), "Inlcude a P.O. number or relevant comments if needed.", /*#__PURE__*/_react.default.createElement("br", null), "For special instructions, including in-store pickup, use the comment section.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("i", {
        style: {
          color: '#e01a89'
        }
      }, "Note: Orders under $300 will incur a delivery fee."), /*#__PURE__*/_react.default.createElement("br", null), "Click \"Submit Order\" to finalize your submission."), /*#__PURE__*/_react.default.createElement("a", {
        href: "catalog/PRODUCTS/PRO-SITE-FEATURED"
      }, /*#__PURE__*/_react.default.createElement("p", null, "Continue Shopping"))), this.contents.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "price-container"
      }, /*#__PURE__*/_react.default.createElement("h3", null, "Order Total"), /*#__PURE__*/_react.default.createElement("h3", {
        className: "price"
      }, Cart.formatPrice(Cart.getTotal(this.contents))), this.cartRef && /*#__PURE__*/_react.default.createElement("a", {
        href: "javascript:void(0)",
        "data-spin": this.cartRef.state.isSubmitting ? 'true' : void 0,
        onClick: this.cartRef.placeOrder,
        className: _classList.default.join('btn', 'btn-primary', this.cartRef.state.isSubmitting && 'spinning')
      }, "Submit Order")) : /*#__PURE__*/_react.default.createElement("div", {
        className: "price-container"
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "block stack text height-auto",
        "data-block-type": "freeformText",
        "data-block-id": "orderReview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "inner-content container"
      }, /*#__PURE__*/_react.default.createElement(Cart, {
        ref: this.gotCart,
        contents: this.contents,
        mode: "OrderDetail"
      }))));
    }
  }]);
  return CartPage;
}(_react.Component), (_descriptor22 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "clientName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "yourName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = babelHelpers.applyDecoratedDescriptor(_class9.prototype, "contents", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "gotCart", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "gotCart"), _class9.prototype)), _class9));
exports.CartPage = CartPage;